import script from "./KnockoutsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./KnockoutsTable.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/table.css?vue&type=style&index=0&id=bf84451c&scoped=true&lang=css&external"
import "./KnockoutsTable.vue?vue&type=style&index=1&id=bf84451c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf84451c"]])

export default __exports__